import styled from 'styled-components'
import { DEVICE } from '../../../util/constants'
import { GriddedContentBlock } from '../../styles/Utility.styles'

export const CalendarOfEventsBlock = styled(GriddedContentBlock)`
  /* Naming Convenience */
  margin-top: 0;
`

export const CalendarGrid = styled.div`
  grid-column: 2 / 12;
  display: grid;
  grid-template-columns: 1fr;

  @media ${DEVICE.laptopL} {
    grid-template-rows: 1fr max-content;
    grid-template-columns: 1fr 1fr 1fr;
  }

  [data-layout='two-column'] & {
    @media ${DEVICE.laptopG} {
      grid-column: span 12;
    }
  }
`

export const CircleAccent = styled.div`
  border-radius: 50%;
  border: 3px solid var(--graphic-accent-orange-1);
  box-sizing: border-box;
  height: 59px;
  width: 59px;
  z-index: 1;
  grid-row: 1;
  grid-column: 1;
  position: relative;
  right: 128px;
  margin: 0 auto 16px;

  @media ${DEVICE.tabletL} {
    margin: unset;
    position: relative;
    z-index: 1;
    right: 29px;
    bottom: 29px;
  }
`

export const SectionHeader = styled.div`
  z-index: 2;
  background-color: var(--content-background-light);
  grid-row: 1;
  grid-column: 1;
  padding: 23px;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.3;
  letter-spacing: 0.02em;
  color: var(--content-background-dark-blue);
  text-transform: uppercase;
  width: 257px;
  text-align: center;
  margin: 28px auto 32px;

  @media ${DEVICE.tabletL} {
    max-width: max-content;
    min-width: 257px;
    width: unset;
    margin: 0 0 32px;
    font-size: 1.8rem;
    line-height: 1.3;
  }
`

export const CalendarEvent = styled.div`
  margin-bottom: 30px;

  @media ${DEVICE.laptopL} {
    margin-bottom: unset;
    grid-row: 2;
  }
`

export const EventInfoRow = styled.div`
  display: flex;
  flex-direction: row;
`

export const DateBox = styled.div`
  flex-shrink: 0;
  background-color: var(--highlight-blue);
  font-weight: 400;
  font-size: 1.8rem;
  line-height: 1.3;
  margin-bottom: 4px;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  color: var(--content-background-light);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 93px;
  height: 83px;

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
  }
`

export const MultiDateBox = styled(DateBox)`
  font-size: 1.7rem;
  margin: 10px 0;
  letter-spacing: 0.02em;
  text-transform: unset;
  color: var(--content-background-light);

  span {
    height: auto;
  }
`

export const TimeAndLocationBox = styled.div`
  margin-left: 16px;
  display: flex;
  flex-direction: column;
  align-self: center;
  align-items: left;
  font-size: 1.8rem;
  line-height: 1.6;
  color: var(--content-background-dark-blue);

  @media ${DEVICE.tabletL} {
    font-size: 2rem;
  }

  span {
    padding-right: 16px;

    :last-of-type {
      line-height: 1.3;
    }
  }
`

export const EventDetailColumn = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: 30px;
  margin-top: 16px;

  h2 {
    font-size: 2.4rem;
    line-height: 1.36;
    color: var(--content-background-dark-blue);
    margin-bottom: 14px;

    @media ${DEVICE.tabletL} {
      font-size: 2.8rem;
      margin-bottom: 14px;
    }
  }

  p {
    font-size: 1.4rem;
    line-height: 1.375;
    color: var(--content-background-dark-blue);

    @media ${DEVICE.tabletL} {
      font-size: 1.6rem;
      line-height: 1.375;
    }
  }
`
